import React from "react";
import "./EmailVerificationModal.css";

const COPY = {
  login: {
    title: "Confirm your email address",
    body:
      "To protect your account and complete purchases, please verify your email address using the link we sent to your inbox. Until your email is confirmed, you will not be able to check out. If you do not see the message, please check your spam or junk folder.",
    primary: "Resend email",
  },
  checkout: {
    title: "Email verification required",
    body:
      "Please confirm your email address before completing a purchase. Use the verification link we sent you, then return to checkout. This is the same confirmation we ask you to complete after signing in when your email is not yet verified.",
    primary: "Resend email",
  },
};

const EmailVerificationModal = ({
  open = true,
  onClose,
  onResend,
  resendLoading = false,
  resendFeedback = "",
  variant = "login",
}) => {
  if (!open) return null;
  const text = COPY[variant] || COPY.login;

  const handlePrimary = () => {
    if (onResend) {
      onResend();
    } else {
      onClose?.();
    }
  };

  return (
    <div
      className="evm-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="evm-title"
    >
      <div className="evm-panel" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="evm-close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <h2 id="evm-title" className="evm-title">
          {text.title}
        </h2>
        <p className="evm-body">{text.body}</p>
        <button
          type="button"
          className="evm-primary"
          onClick={handlePrimary}
          disabled={resendLoading}
        >
          {resendLoading ? "Sending…" : text.primary}
        </button>
        {resendFeedback ? (
          <p className="evm-feedback" role="status" aria-live="polite">
            {resendFeedback}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default EmailVerificationModal;
